/**
 * Curated executive points of view — primarily LinkedIn posts.
 * Update when new POVs are published.
 */
export const linkedInPointOfViews = [
  {
    id: 'outcomes-per-token-board-kpi',
    title: 'Outcomes Per Token Is The Board-Level KPI',
    excerpt:
      'Shared Oxygen ran 3B tokens across frontier, mid-tier, and local LLMs as deliberate research into AI economics — roughly five developer-years of usage. Token volume is a poor proxy for value. Outcomes-per-token is the real board-level KPI, and model tier selection is a capital allocation decision. Not a usage story — an evidence story. Can you defend what you\'re spending?',
    url: 'https://www.linkedin.com/posts/sharedoxygen_ai-enterpriseai-cto-share-7480475690065317888-pG4_/',
    publishedDate: '2026-07-08',
    imageUrl: '/images/outcomes-per-token-linkedin.svg',
    imageAlt: 'Outcomes Per Token Is The Board-Level KPI — Shared Oxygen AI economics research',
    source: 'LinkedIn',
    author: 'Jeffrey Collins',
  },
  {
    id: 'tokens-strategic-imperative',
    title: 'The Rise Of Tokens As A Strategic Imperative',
    excerpt:
      'Tokens are becoming a balance-sheet line item alongside payroll. Engineer costs rose 40% over a decade while advanced model token prices collapsed by up to 900x annually—reshaping budget allocation, workforce strategy, and competitive position for executive teams.',
    url: 'https://www.linkedin.com/posts/sharedoxygen_the-rise-of-tokens-as-a-strategic-imperative-ugcPost-7452760217005576192-XZdQ/',
    publishedDate: '2026-04-28',
    imageUrl: '/images/tokens-strategic-imperative-linkedin.svg',
    imageAlt: 'The Rise Of Tokens As A Strategic Imperative — Shared Oxygen executive brief',
    source: 'LinkedIn',
    author: 'Jeffrey Collins',
  },
];
